import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Spin } from 'antd';
import { useAuth } from '../contexts/AuthContext';

/**
 * 路由守卫：要求登录
 * - loading: 显示居中 loading
 * - 未登录: 跳到 /login，并把目标路径塞进 state 让登录后能跳回
 * - 已登录: 渲染子节点
 */
export function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}>
        <Spin size="large" tip="加载中..." />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
  }

  return children;
}

/**
 * 路由守卫：要求管理员
 */
export function RequireAdmin({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}>
        <Spin size="large" tip="加载中..." />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
  }

  if (user.role !== 'admin') {
    return (
      <div style={{ padding: '80px 24px', textAlign: 'center' }}>
        <h2 style={{ color: '#ff4d4f', marginBottom: 16 }}>403 · 无权访问</h2>
        <p style={{ color: '#666' }}>此页面需要管理员权限。</p>
        <a href="/" style={{ color: '#1890ff' }}>← 返回首页</a>
      </div>
    );
  }

  return children;
}

export default ProtectedRoute;
